import { useEffect, useState } from "react";
import api from "./api";

// Live exchange rates for the session. Fetched once (the backend serves a
// server-side cached ECB day), shared by every component that needs it.
// Failure is silent — components fall back to the project's locked rate.
let cache = null;
let inflight = null;

export function useFx() {
  const [fx, setFx] = useState(cache);
  useEffect(() => {
    if (cache) return undefined;
    if (!inflight) {
      inflight = api
        .get("/fx/latest")
        .then((r) => {
          cache = r.data;
          return r.data;
        })
        .catch(() => null);
    }
    const p = inflight;
    let alive = true;
    p.then((d) => {
      if (alive && d) setFx(d);
    });
    return () => {
      alive = false;
    };
  }, []);
  return fx;
}
